import DestacatDtyDestacat from './DestacatDtyDestacat';
import DestacatDtyDestacatSkeleton from './DestacatDtyDestacatSkeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <DestacatDtyDestacatSkeleton /> : <DestacatDtyDestacat {...props} />;
}
